import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { reject } from 'lodash/fp';
import {
  requestInitalData,
  toggleContentType,
  requestJourneyData,
  requestData,
} from 'actions/assign';
import { ORDER, COLUMNS, TYPES } from 'constants/config';
import { hasFeatureFlags } from 'utils/features';
import { TabbedView, TabList, Tab } from 'components/shared/TabbedView';
import { BetaLabel } from 'components/BetaProgram';
import AssignableCollection from '../shared/AssignableCollection';
import Search from '../shared/Search';
import Filter from '../shared/Filter';
import Sort from '../shared/Sort';
import ResultsCount from '../shared/ResultsCount';

class ContentView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasLearningJourneys: hasFeatureFlags(['readiness-learning-journeys']),
    };
  }

  componentDidMount() {
    this.props.requestInitalData();

    if (this.state.hasLearningJourneys) {
      this.props.requestJourneyData();
    }
  }

  componentWillUnmount() {
    this.props.toggleContentType(0);
  }

  static sortOptions = [
    {
      order: ORDER.DESC,
      type: COLUMNS.LAST_MODIFIED,
      label: 'Recently Updated',
    },
    { order: ORDER.ASC, type: COLUMNS.TITLE, label: 'Name A-Z' },
    { order: ORDER.DESC, type: COLUMNS.TITLE, label: 'Name Z-A' },
  ];

  static filterOptions = [
    { value: 'Lesson', label: 'Lessons' },
    { value: 'Resource', label: 'Resources' },
    { value: TYPES.PATH, label: 'Paths' },
  ];

  get filterOptions() {
    let { filterOptions } = ContentView;
    if (!this.props.hasResourceExperiment) {
      filterOptions = reject({ value: 'Resource' })(filterOptions);
    }

    filterOptions = reject({ value: TYPES.PATH })(filterOptions);
    filterOptions.push({
      value: TYPES.PATH,
      label: 'Paths & Certification Paths',
    });

    return filterOptions;
  }

  handleContentToggle(index) {
    this.props.toggleContentType(index);
    if (index === 0) {
      this.props.requestData();
    } else {
      this.props.requestJourneyData();
    }
  }

  render() {
    const isJourneyList = this.props.contentType === 1;
    const hasSearchInput =
      this.props.searchInput && this.props.searchInput.length > 0;

    return (
      <div className="AssignModal-detailsView">
        <Search
          placeholder="Search content"
          getFiltersRef={() => this.filters}
        />
        {this.state.hasLearningJourneys && (
          <div className="AssignModal-contentToggle">
            <TabbedView
              onSelect={index => this.handleContentToggle(index)}
              selectedIndex={this.props.contentType}
            >
              <TabList>
                <Tab>{t('contents.index.toggle.training_content')}</Tab>
                <Tab>
                  {t('contents.index.toggle.learning_journeys')}
                  <BetaLabel className="ml-8" whiteOnBlack />
                </Tab>
              </TabList>
            </TabbedView>
          </div>
        )}
        <div
          ref={n => {
            this.filters = n;
          }}
          className="AssignModal-filters"
        >
          {isJourneyList && !hasSearchInput ? (
            <div>
              {t('journeys.assign.all')}{' '}
              {this.props.journeyData.length > 0 &&
                `(${this.props.journeyData.length})`}
            </div>
          ) : (
            <>
              {this.props.searchInput && this.props.searchInput.length > 0 && (
                <ResultsCount />
              )}
            </>
          )}
          <div
            className="AssignModal-typePillsWrapper"
            style={hasSearchInput || isJourneyList ? { display: 'none' } : {}}
          >
            <Filter options={this.filterOptions} />
          </div>
          <Sort options={this.constructor.sortOptions} />
        </div>
        <AssignableCollection />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasResourceExperiment: state.meta.features.resource_experiment,
  contentType: state.contentType,
  journeyData: state.journeyData,
  searchInput: state.params.query,
});

const mapDispatchToProps = dispatch => ({
  requestInitalData() {
    dispatch(requestInitalData());
  },
  toggleContentType(type) {
    dispatch(toggleContentType(type));
  },
  requestJourneyData() {
    dispatch(requestJourneyData());
  },
  requestData() {
    dispatch(requestData());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentView);
